import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=0fbb7f7f"
import script from "./VideoEdit.vue?vue&type=script&lang=js"
export * from "./VideoEdit.vue?vue&type=script&lang=js"
import style0 from "./VideoEdit.vue?vue&type=style&index=0&id=0fbb7f7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports